function _addRelativeDateRangeInfoIfLegacy(dateFilter) {
  // Continue only if 'dateFilter' is in the legacy format
  if (dateFilter.type !== 'relative' || (dateFilter.values && dateFilter.values.relative)) {
    return;
  }

  const { from: _from, to: _to } = dateFilter;
  const from = new Date(_from);
  const to = new Date(_to);
  const relativeDiffInDays = moment(to).diff(from, 'days');

  const relativeDateRangeInfo = {
    unit: 'D',
    value: relativeDiffInDays + 1, // covers 'Yesterday' and other relarive date ranges
    isConstructedUsingLegacyInfo: true,
  };

  // Special case) If 'from' and 'to' are same and a user selects 'Today'
  if (relativeDiffInDays === 0 && moment(to).isSame(moment(), 'day')) {
    relativeDateRangeInfo.value = 0; // Special case.
  }

  dateFilter.values = dateFilter.values === undefined ? {} : dateFilter.values;
  dateFilter.values.relative = relativeDateRangeInfo;
}

module.exports = {
  _addRelativeDateRangeInfoIfLegacy,
};
